<template>
  <div class="mb-3">
    <h2 class="fw-light d-flex align-items-center mb-0">
      <router-link
        to="/documents/moviments"
        class="d-flex align-items-center me-2"
        title="Voltar"
      >
        <i class="ph-caret-circle-left ph-2x" />
      </router-link>
      Detalhes da compra de pequeno vulto
    </h2>
  </div>
  <LoadingData v-if="isLoadingMoviment" />
  <DetailsMoviment v-else :moviment="moviment" />
  <div
    class="card card-body border-start border-start-width-2 border-start-primary"
  >
    <ul
      class="nav nav-pills nav-pills-outline nav-pills-toolbar nav-justified"
      role="tablist"
    >
      <li class="nav-item">
        <a
          type="button"
          role="tab"
          class="nav-link active"
          data-bs-toggle="tab"
          data-bs-target="#new-measure"
          aria-controls="new-measure"
          aria-selected="true"
          title="Nova Medição"
        >
          Nova Medição
        </a>
      </li>
      <li class="nav-item">
        <a
          type="button"
          role="tab"
          class="nav-link"
          data-bs-toggle="tab"
          data-bs-target="#itens"
          aria-controls="itens"
          aria-selected="false"
          title="Saldos Disponíveis"
        >
          Saldos Disponíveis
        </a>
      </li>
      <li class="nav-item">
        <a
          type="button"
          role="tab"
          class="nav-link"
          data-bs-toggle="tab"
          data-bs-target="#measures"
          aria-controls="measures"
          aria-selected="false"
          title="Medições"
        >
          Medições
          <span
            class="badge bg-teal rounded-pill ms-2"
            title="Total de medições"
          >
            {{ measures.length }}
          </span>
          <span
            v-if="measuresWaiting.length > 0"
            class="badge bg-yellow rounded-pill ms-2"
            title="Medições aguardando aprovação"
          >
            {{ measuresWaiting.length }}
          </span>
        </a>
      </li>
      <li class="nav-item">
        <a
          type="button"
          role="tab"
          class="nav-link"
          data-bs-toggle="tab"
          data-bs-target="#documents"
          aria-controls="documents"
          aria-selected="false"
          title="Certidões"
        >
          Certidões
          <span
            class="badge bg-teal rounded-pill ms-2"
            title="Total de certidões"
          >
            {{ documents.length }}
          </span>
        </a>
      </li>
    </ul>
    <div class="tab-content">
      <div
        class="tab-pane fade show active"
        id="new-measure"
        role="tabpanel"
        aria-labelledby="new-measure-tab"
      >
        <LoadingData v-if="isLoadingMoviment" class="mt-3" />
        <NewMeasureMoviment
          v-else
          :moviment="moviment"
          @getMeasures="getMeasures"
        />
      </div>
      <div
        class="tab-pane fade"
        id="itens"
        role="tabpanel"
        aria-labelledby="itens-tab"
      >
        <LoadingData v-if="isLoadingItens" class="mt-3" />
        <ItensMoviment v-else :itens="itens" />
      </div>
      <div
        class="tab-pane fade"
        id="measures"
        role="tabpanel"
        aria-labelledby="measures-tab"
      >
        <LoadingData v-if="isLoadingMeasures" class="mt-3" />
        <MeasuresMoviment
          v-else
          :measures="measures"
          @getMeasures="getMeasures"
        />
      </div>
      <div
        class="tab-pane fade"
        id="documents"
        role="tabpanel"
        aria-labelledby="documents-tab"
      >
        <LoadingData v-if="isLoadingDocuments" class="mt-3" />
        <div v-else class="mt-3">
          <SupplierDocuments
            :supplier="moviment"
            :documents="documents"
            @getSupplierDocuments="getSupplierDocuments"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import LoadingData from '@/components/commons/LoadingData.vue'
import DetailsMoviment from '@/components/documents/moviments/DetailsMoviment.vue'
import NewMeasureMoviment from '@/components/documents/moviments/NewMeasureMoviment.vue'
import ItensMoviment from '@/components/documents/moviments/ItensMoviment.vue'
import MeasuresMoviment from '@/components/documents/moviments/MeasuresMoviment.vue'
import SupplierDocuments from '@/components/documents/suppliers/SupplierDocuments.vue'
import MeasureStatusEnum from '@/enum/measureStatusEnum'
import { removeCnpjCharacteres } from '@/utils/strings'

export default {
  name: 'MovimentDetails',

  components: {
    LoadingData,
    DetailsMoviment,
    NewMeasureMoviment,
    ItensMoviment,
    MeasuresMoviment,
    SupplierDocuments,
  },

  data() {
    return {
      idMov: this.$route.params.idMov,
      isLoadingMoviment: true,
      isLoadingItens: true,
      isLoadingMeasures: true,
      isLoadingDocuments: true,
      moviment: null,
      itens: [],
      measures: [],
      measuresWaiting: [],
      documents: [],
    }
  },

  methods: {
    async getMoviment() {
      try {
        this.moviment = await this.$store.dispatch('getMoviment', this.idMov)

        this.moviment.supplierType = 'Requisição'
        this.moviment.supplierName = this.moviment.fornecedor
        this.moviment.supplierDocument = this.moviment.cnpj

        this.isLoadingMoviment = false

        this.getItens()
        this.getMeasures()
        this.getSupplierDocuments()
      } catch (error) {
        if (error && error.message) {
          this.$root.$refs.notification.warning(error.message)
        } else {
          this.$root.$refs.notification.error(
            'Não foi possível se conectar ao servidor.',
          )
        }
      }
    },

    async getItens() {
      try {
        this.isLoadingItens = true

        this.itens = await this.$store.dispatch('getMovimentItens', this.idMov)

        this.isLoadingItens = false
      } catch (error) {
        if (error && error.message) {
          this.$root.$refs.notification.warning(error.message)
        } else {
          this.$root.$refs.notification.error(
            'Não foi possível se conectar ao servidor.',
          )
        }
      }
    },

    async getMeasures() {
      try {
        this.isLoadingMeasures = true

        this.measures = await this.$store.dispatch(
          'getMovimentMeasures',
          this.idMov,
        )

        this.measuresWaiting = this.measures.filter(function (measure) {
          return (
            measure.status === MeasureStatusEnum.AGUARDANDO_APROVACAO ||
            measure.status === MeasureStatusEnum.APROVADO_GESTOR
          )
        })

        this.isLoadingMeasures = false
      } catch (error) {
        if (error && error.message) {
          this.$root.$refs.notification.warning(error.message)
        } else {
          this.$root.$refs.notification.error(
            'Não foi possível se conectar ao servidor.',
          )
        }
      }
    },

    async getSupplierDocuments() {
      try {
        this.isLoadingDocuments = true

        this.documents = await this.$store.dispatch(
          'getSupplierDocuments',
          removeCnpjCharacteres(this.moviment.cnpj),
        )

        this.isLoadingDocuments = false
      } catch (error) {
        if (error && error.message) {
          this.$root.$refs.notification.warning(error.message)
        } else {
          this.$root.$refs.notification.error(
            'Não foi possível se conectar ao servidor.',
          )
        }
      }
    },
  },

  mounted() {
    this.getMoviment()
  },
}
</script>
